import React, { useState } from "react";
import { Col, Divider, Form, Input, Modal, Row, Tooltip, Space } from "antd";
import { PRIMARY_COLOR, PRINT_COLOR, SUCCESS_COLOR, WHITE_COLOR } from "../../constants/color";
import { Typography, theme } from 'antd';
import ColorButton from "../../common/ColorButton";
import {
  ExclamationCircleOutlined,
  PrinterOutlined
} from '@ant-design/icons';
import AddChemicalCard from "./AddChemicalCard";
import { GET, POST } from "../../frameworks/HttpClient";
import { URL_COMMON, URL_LAB, URL_REPORT } from "../../constants/urls";
import AddListChemical from "../pond-latex/AddListChemical";
import { LAB_ACTION } from "../../constants/string";
import ReportButton from "../common/ReportButton";
import _ from "lodash";
import { useUserContext } from "../../hooks/UserSettingProvider";

export default function LabAddChemicalModal(props) {
  const { open, onClose, target, onUpdate } = props;
  const { features } = useUserContext();
  const stockFeature = _.get(features, 'lab_input_stock_feature', false)
  const { Title } = Typography;
  const [errorMessages , setErrorMessages] = useState (null);
  const {
    token: { colorError, colorSuccess },
  } = theme.useToken();

  const handleAddChemical = async() => {
    try {
      await POST(`${URL_LAB.LAB_ORDER}${target.id}/${LAB_ACTION.INPUT}/`)
      onUpdate()
    } catch (error) {
      setErrorMessages(error.errorMessages);
    }
  }
 
  React.useEffect(() => {
    if(open){
      setErrorMessages(null)
    }
  },[open])
  
  return (
    <Modal
      open={open}
      onCancel={onUpdate}
      okText={"ยืนยัน"}
      cancelText={"ยกเลิก"}
      width={950}
      style={{ minWidth : 950, marginTop : 50, marginBottom : 50}}
      centered
      title={<Title level={5} style={{ margin : 4}}>คำสั่งเติมสารเคมี</Title>}
      footer={
        <Space>
            {stockFeature && <ReportButton
              hideIcon={true} 
              url={`${URL_REPORT.LAB_INPUT_ORDER_ALL}${_.get(target ,'id', '')}`}
              style={{ float : 'right'}}
              >
              พิมพ์รายการสั่งเติมสารเคมีทั้งหมด
            </ReportButton>}
          <ColorButton 
            override={PRINT_COLOR}
            style={{ float : 'right' }}
            onClick={onUpdate} 
          >
            ปิด
          </ColorButton>
          {!stockFeature && <ColorButton 
            type={"primary"}
            override={colorSuccess}
            style={{ float : 'right' }}
            onClick={() => handleAddChemical()} 
          >
            เติม
          </ColorButton>}
        </Space>
      }
      destroyOnClose
    >
      {stockFeature && <AddChemicalCard order={target} />}
      {!stockFeature && <AddListChemical target={target} />}
    </Modal>
  )
}